var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3129 6.1626L10.6825 0.918558C10.3434 0.693814 9.91947 0.693814 9.66512 0.918558L2.03469 6.1626C1.78034 6.31243 1.69556 6.53717 1.69556 6.76192V15.0026C1.69556 16.2761 2.79773 17.25 4.23904 17.25H16.1086C17.5499 17.25 18.6521 16.2761 18.6521 15.0026V6.76192C18.6521 6.53717 18.5673 6.31243 18.3129 6.1626ZM11.8695 9.75851V15.7517H8.47817V9.75851H11.8695ZM16.1086 15.7517C16.6173 15.7517 16.9564 15.452 16.9564 15.0026V7.13649L10.1738 2.49177L3.39121 7.13649V15.0026C3.39121 15.452 3.73034 15.7517 4.23903 15.7517H6.78251V9.00936C6.78251 8.55988 7.12164 8.26022 7.63034 8.26022H12.7173C13.226 8.26022 13.5651 8.55988 13.5651 9.00936V15.7517H16.1086Z",
    fill: "#852A29"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_746_94101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3129 6.1626L10.6825 0.918558C10.3434 0.693814 9.91947 0.693814 9.66512 0.918558L2.03469 6.1626C1.78034 6.31243 1.69556 6.53717 1.69556 6.76192V15.0026C1.69556 16.2761 2.79773 17.25 4.23904 17.25H16.1086C17.5499 17.25 18.6521 16.2761 18.6521 15.0026V6.76192C18.6521 6.53717 18.5673 6.31243 18.3129 6.1626ZM11.8695 9.75851V15.7517H8.47817V9.75851H11.8695ZM16.1086 15.7517C16.6173 15.7517 16.9564 15.452 16.9564 15.0026V7.13649L10.1738 2.49177L3.39121 7.13649V15.0026C3.39121 15.452 3.73034 15.7517 4.23903 15.7517H6.78251V9.00936C6.78251 8.55988 7.12164 8.26022 7.63034 8.26022H12.7173C13.226 8.26022 13.5651 8.55988 13.5651 9.00936V15.7517H16.1086Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_746_94101)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.3478,
    height: 18,
    fill: "#852A29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboardActive.adce1768e5d7bb30df58f29cddcf4436.svg";
export { ForwardRef as ReactComponent };